export default "__VITE_ASSET__CzFEzeIZ__"